import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { MODAL_ADMIN_CHANGE_CODE } from 'redux/modules/modals'
const styles = theme => ({
  root: {
    width: '100%'
  }
})
export default withStyles(styles)(
  class AdminGeneralComponent extends Component {
    static propTypes = {
      adminCode: PropTypes.string.isRequired,
      showModal: PropTypes.func.isRequired,
      classes: PropTypes.object.isRequired
    }
    handleChangeCode = e => {
      this.props.showModal(MODAL_ADMIN_CHANGE_CODE)
    }
    componentDidMount() {}
    render() {
      const { adminCode, classes } = this.props
      return (
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="flex-start"
          spacing={0}>
          <Paper className={classes.root}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center">
              <Grid item>
                <TextField
                  id="number"
                  label="Code Administrateur"
                  disabled
                  value={adminCode}
                  type="number"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  margin="normal"
                />
              </Grid>
              <Grid item>
                <Button
                  style={{ margin: 10 }}
                  variant="raised"
                  color="secondary"
                  onClick={this.handleChangeCode}>
                  Changer le code Admin
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/components/general/AdminGeneralComponent.js